<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterConfig"
      @filter-search-input="handleFilterSearchInput"
      @filter-value-change="handleFilterValueChange"
      @tab-change="handleTabChange"
      :noResetCall="true"
      :enable-tabs="true"
      :tabs="filterTabItems"
    />

    <SettlementInfoBanner v-if="!isTabCpts" class="mx-4 mt-4" />

    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:exportItemParent="exportItem"
          v-on:exportExcelParent="exportExcel"
          :switchCh="switchCh"
          v-on:onSwitch="handleSwitch"
        />
      </template>
      <template v-slot:[`header.settlement_datetime`]>
        <HeaderTooltipInfo
          value="Settlement Date"
          title="Settlement Bertahap (WIB)"
          description="Tanggal ini mengikuti jadwal batch (5x/hari untuk H+0, 1x/hari untuk H+1), sesuai Waktu Indonesia Barat. Detail jam lengkap ada di banner info di atas tabel."
        />
      </template>
      <template v-slot:tooltip__qr_method="{ item }">
          <TooltipInformation
            :value="item.qr_method"
            :description="getTooltipMethod(item)"
          />
      </template>
      <template v-slot:tooltip__payment_type="{ item }">
        <TooltipInformation
          :value="item.payment_type"
          :description="getTooltipPayement(item)"
        />
      </template>
        <template slot="action" slot-scope="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon small class="mr-2" @click="viewItem(item.id)"> mdi-eye </v-icon>
        </td>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="500px">
      <table-detail :editedItem="editedItem" :tabType="currentTab" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import reportMerchantTransactionMixin from '../../components/report/merchant-transaction/reportMerchantTransactionMixin';


export default {
  mixins: [ reportMerchantTransactionMixin ],
  components: {
    TableDetail: () =>
      import('../../components/table/MerchantTransactionDetail.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TooltipInformation: () => import("../../components/@drontVue/components/TooltipInformation"),
    HeaderTooltipInfo: () => import("../../components/@drontVue/components/HeaderTooltipInfo"),
    SettlementInfoBanner: () => import("../../components/@drontVue/components/SettlementInfoBanner")
  },

};
</script>